import React from 'react';
import styled from 'styled-components';

interface ICheckboxControl {
  controlName: string;
  controlValue: any;
  applySettings: (controlName: string, controlValue: any, newValues: any) => void;
}

export const CheckboxControl = (props: ICheckboxControl): JSX.Element => {
  const { controlName, controlValue, applySettings } = props;
  return (
    <StyledCheckbox
      type="checkbox"
      checked={controlValue.value}
      onChange={(e) => {
        applySettings(controlName, controlValue, { value: e.target.checked });
      }}
    />
  );
};

const StyledCheckbox = styled.input`
  width: 30px;
  height: 30px;

  margin-top: 8px !important;
`;
